module.exports = __webpack_public_path__ + "img/5f_r_torikoma.6769c9f9.png";